@use "ui/oldStyles/utils";
@use "ui/oldStyles/theme";

.wrapper {
  @include utils.landing-page;
  background-color: theme.fetch(theme.$light, "colors", "background");

  :global {
    .top {
      box-shadow: 0 -1px 0 0 theme.fetch(theme.$light, "colors", "dividers");
    }

    .bottom {
      box-shadow: 0 1px 0 0 theme.fetch(theme.$light, "colors", "dividers");
    }
  }
}

.ctaWrapper {
  margin-bottom: 50px;
}